module.exports = __webpack_public_path__ + "img/1 (107).95d38a2d.png";